import { SiDiscord, SiTwitch } from "react-icons/si";
import { BRAND, NAV_LINKS } from "@/lib/brand";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-[#D4AF37]/15"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-sm overflow-hidden ring-1 ring-[#D4AF37]/40 bg-black">
              <img
                src={BRAND.logoUrl}
                alt="TGL"
                className="w-full h-full object-cover scale-[2.2] translate-y-1"
              />
            </div>
            <span className="font-display text-base font-bold tracking-[0.25em] text-white">
              THE GOLDEN LEGENDS
            </span>
          </div>
          <p className="mt-5 max-w-md text-sm text-zinc-400">
            A championship esports house, gaming studio, and global community.
            Forged in gold. Crowned in glory.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href={BRAND.discordUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-discord"
              className="w-10 h-10 grid place-items-center border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-zinc-400 transition-colors cut-corners"
              aria-label="Discord"
            >
              <SiDiscord size={16} />
            </a>
            <a
              href={`https://twitch.tv/${BRAND.twitchChannel}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-twitch"
              className="w-10 h-10 grid place-items-center border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-zinc-400 transition-colors cut-corners"
              aria-label="Twitch"
            >
              <SiTwitch size={16} />
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-4">
            Navigate
          </h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-sm text-zinc-400 hover:text-[#D4AF37] transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-4">
            HQ
          </h4>
          <p className="text-sm text-zinc-400">
            TGL HQ · Online & Worldwide
            <br />
            Press, sponsors, and bookings:
            <br />
            <a
              href={`mailto:${BRAND.contactEmail}`}
              className="text-zinc-200 hover:text-[#D4AF37]"
            >
              {BRAND.contactEmail}
            </a>
          </p>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[10px] uppercase tracking-[0.3em] text-zinc-600">
          <p>© {new Date().getFullYear()} The Golden Legends. All Crowns Reserved.</p>
          <p>Forged in Gold · Crowned in Glory</p>
        </div>
      </div>
    </footer>
  );
}
